import Avatar from 'material-ui/Avatar';
import React from 'react'

import inspirationalQuoteConfig from '../../configs/inspirational-quote-config'

const _getRandomQuote = (obj) => {
  const keys = Object.keys(obj);
  return obj[keys[ keys.length * Math.random() << 0]];
};

const InspirationalQuote = () => {
  const {job, name, photo, quote} = _getRandomQuote(inspirationalQuoteConfig);

  return (
    <div className="inspirational-quote-wrapper">
      <div className="inspirational-quote">
        <Avatar size={70} src={photo} />
          <div className="inspirational-quote inline-block">
            <p className="inspirational-quote-text">
              {`"${quote}"`}
            </p>
            <p className="inspirational-quote-author">
              {`-${name}, ${job}`}
            </p>
        </div>
      </div>
    </div>
  );
}

export default InspirationalQuote



// WEBPACK FOOTER //
// ./src/components/Home/InspirationalQuote.js